<template>
  <b-dropdown
    aria-role="list"
    class="card-drop-simple dropdown-container"
    position="is-bottom-left"
    title="Filtrar"
  >
    <div slot="trigger" @click="filterVisibility = true">
      <KButton
        slot="trigger"
        height="34px"
        width="unset"
        font-weight="400"
        font-size="0.8125rem"
        border-radius="0.25rem"
        @click="filterVisibility = true"
      />
    </div>

    <div v-if="filterVisibility" class="container-dropdown">
      <div class="header-container-filter">
        <b-button type="is-danger is-small" outlined @click="clearFilter()">
          Limpar
        </b-button>
        <h1 class="header-filtros-header">
          Filtros
        </h1>
        <b-button
          type="is-primary is-small"
          @click="
            sendFilter({
              status: status,
              createdCheckbox: createdCheckbox,
              createdAt: createdAt,
            })
          "
        >
          Aplicar
        </b-button>
      </div>
      <div class="filters-container">
        <b-field label="Status" custom-class="is-small">
          <b-select v-model="status" size="is-small" placeholder="Selecione o Status" expanded>
            <option :value="2">
              Tudo
            </option>
            <option :value="1">
              Ativo
            </option>
            <option :value="0">
              Inativo
            </option>
          </b-select>
        </b-field>
        <div class="situation-pedido-box">
          <b-checkbox v-model="createdCheckbox" size="is-small" class="checkbox-situation-pedido">
            Data de Criação
          </b-checkbox>
          <div v-if="createdCheckbox" class="situation-box-input">
            <feather type="corner-down-right" size="18" class="arrow-indicator" />
            <div class="grouped-situation-input">
              <b-input
                v-model="createdAt[0]"
                type="date"
                size="is-small"
                class="input-date-picker"
              />
              <b-input
                v-model="createdAt[1]"
                type="date"
                size="is-small"
                class="input-date-picker"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-dropdown>
</template>

<script>
import KButton from '../buttons/Default';

export default {
	components: {
		KButton,
	},
	data() {
		return {
			createdAt: ['', ''],
			createdCheckbox: false,
			status: 2,
			filterVisibility: false,
		};
	},
	created() {
		if (localStorage.getItem('filter-users')) {
			const { createdCheckbox, interval, status } = JSON.parse(
				localStorage.getItem('filter-users')
			);
			this.createdCheckbox = createdCheckbox;
			this.createdAt[0] = interval.from;
			this.createdAt[1] = interval.to;
			this.status = status;
		}
	},
	methods: {
		clearFilter() {
			localStorage.removeItem('filter-users');
			this.createdAt = ['', ''];
			this.createdCheckbox = false;
			this.status = 2;
		},
		sendFilter(params) {
			const { status, createdCheckbox, createdAt } = params;

			let sendData = {
				status: null,
				createdCheckbox: false,
				createdAt: ['', ''],
			};
			if (createdCheckbox && createdAt[0].length > 0 && createdAt[1].length > 0) {
				sendData.createdCheckbox = createdCheckbox;
				sendData.createdAt = createdAt;
			}
			if (status >= 0 && status !== 2) {
				sendData.status = status;
			}
			localStorage.setItem(
				'filter-users',
				JSON.stringify({
					interval: {
						from: sendData.createdAt[0],
						to: sendData.createdAt[1],
					},
					status: sendData.status,
					createdCheckbox: sendData.createdCheckbox,
				})
			);
			sendData = {
				interval: {
					from: sendData.createdAt[0],
					to: sendData.createdAt[1],
				},
				status: sendData.status,
				createdCheckbox: sendData.createdCheckbox,
			};
			this.$emit('filter', sendData);
		},
	},
};
</script>

<style lang="scss" scoped>
.filter {
	cursor: pointer;
	align-items: center;
	justify-content: center;
	display: flex;
	padding-left: 10px;
	padding-top: 5px;
	padding-bottom: 5px;
	padding-right: 10px;
	font-size: 0.8125rem;
	line-height: 1.5;
	border-radius: 0.25rem;
	border: 1px solid #e2e2e2;
	height: 100%;
}

.grouped-situation-input {
	display: flex;
	width: 89%;
	justify-content: space-between;
}
.situation-box-input {
	align-items: center;
	display: flex;
	margin-top: 7px;
}
.input-date-picker {
	width: 50%;
}
.input-date-picker:first-child {
	margin-right: 4px;
	margin-left: 4px;
}

.filter:hover {
	border: 1px solid #8f86be;
}

.filtro-icone {
	color: #3c4257;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	margin-left: 4px;
}
.filters-container {
	margin-top: 20px;
	padding: 10px;
}

.card-drop-simple {
	color: #343a40;
	position: relative;
}

.header-container-filter {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px;
	background: #f3f3f387;
	border-bottom: 1px solid gainsboro;
}
.header-filtros-header {
	font-size: 14px;
}
.container-dropdown {
	width: 350px;
	display: flex;
	flex-direction: column;
	// background-color: white;
	// padding: 10px;
}
</style>
